/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2025-06-05 09:46:58
 * @LastEditors: linxi
 * @LastEditTime: 2025-07-14 10:07:46
 */
import React, { ReactElement, useRef, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { TabBar, TabPane } from '../../compnents/widgets/TabBar'
import { BusinessManagementList } from './businessManagement/businessManagement'
import { VarietyManagementList } from './varietyManagement/varietyManagement'

export const FirstTimeBusinessManagementTabs = (): ReactElement => {
  const location: any = useLocation()
  
  const [selectKey, setSelectKey] = useState<any>('0')

  return (
    <TabBar
      style={{ margin: '10px 20px' }}
      defaultActiveKey={location.state ? location.state.selectKey : selectKey || '0'}
      onChange={(v) => {
        setSelectKey(v)
      }}
    >
      <TabPane key='0' tab='首营企业管理'>
        <BusinessManagementList selectKey={selectKey}></BusinessManagementList>
      </TabPane>
      <TabPane key='1' tab='首营品种管理'>
        <VarietyManagementList selectKey={selectKey}></VarietyManagementList>
      </TabPane>
    </TabBar>
  )
}
